import { FilterListGlobalForm } from 'common/pages/filter-list-global/FilterListGlobalForm.tsx'

export const FilterListGlobalFormAdmin = (props: any) => <FilterListGlobalForm {...props} mode={props.mode} admin />
